import DefaultHeading from '../../../components/molecules/defaultHeading/DefaultHeading';
import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import React from 'react';

const TitleTastic = ({ data, context }) => {
  if (!data) return null;

  const locale = context?.locale === 'en_AU@AUD' ? 'AU' : 'NZ';
  if (!data[`show${locale}`]) return null;

  return (
    <DefaultHeading
      label={data.label}
      padding={data.padding}
      labelDesktopLineHeight={data.labelDesktopLineHeight}
      labelDesktopFontSize={data.labelDesktopFontSize}
      labelMobileFontSize={data.labelMobileFontSize}
      title={data.title}
      titleDesktopFontSize={data.titleDesktopFontSize}
      titleMobileFontSize={data.titleMobileFontSize}
      subtitle={data.subTitle}
      subTitleDesktopFontSize={data.subTitleDesktopFontSize}
      subTitleMobileFontSize={data.subTitleMobileFontSize}
      subTitleMobileLineHeight={data.subTitleMobileLineHeight}
      labelTextTransform={data.labelTextTransform}
      subtitleTextTransform={data.subtitleTextTransform}
      titleTextTransform={data.titleTextTransform}
    />
  );
};

export default tastify({ translate: true, connect: { context: true } })(TitleTastic);
